export const ACCOUNT_COST_LIST_TABLE_ROW_DELETE = "ACCOUNT_COST_LIST_TABLE_ROW_DELETE";
export const ACCOUNT_COST_LIST_TABLE_ROW_UPDATE =  "ACCOUNT_COST_LIST_TABLE_ROW_UPDATE";